const en_master_goodsPriceTier = {

}

export default en_master_goodsPriceTier;